// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createWarrantyExpiration} from '../../shared/repositories';

export const createWarrantyExpirationReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const warrantyExpirationReport = getState().reports.warrantyExpiration;

        const reportCriteria = {
            dealers: warrantyExpirationReport.criteria.selectedDealers,
            expirationDateFrom: warrantyExpirationReport.criteria.expirationDate.from,
            expirationDateTo: warrantyExpirationReport.criteria.expirationDate.to,
            warrantyTypes: warrantyExpirationReport.criteria.warrantyTypes.selected
        };

        try {

            const data = await createWarrantyExpiration(reportCriteria);

            dispatch({
                data,
                type: actions.CREATE_WARRANTY_EXPIRATION_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/action-creators/report.js